import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NewOrderApi, OrderSubmitCsvError } from '../api/newOrderApi';
import { OrderViaCsv } from '../types';

import { QUERY_KEY_ORDERS } from './useOrders';

interface Params {
  addOrderWithFile: OrderViaCsv;
}

export const useNewOrderSubmitCsv = () => {
  const queryClient = useQueryClient();
  return useMutation<void, OrderSubmitCsvError, Params>({
    mutationFn: async ({ addOrderWithFile }) =>
      await NewOrderApi.newOrderSubmitCsv(addOrderWithFile),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_ORDERS],
      });
    },
  });
};
